import { Box, Link, Typography } from "@mui/material";
import { linkStyling } from "../styles/styling";

// COMPONENTS
import Definition from "./Definition";
import ProtectedAnimal from "./ProtectedAnimal";

// PROTECTED ANIMALS
export default function ProtectedAnimals() {
    return (
        <Box component="section" id="protectedanimals" display="flex" flexDirection="column" sx={{ mt: 5 }}>
            <Box>
                <Typography variant="h5" fontFamily="Public Sans" color="white" sx={{ mb: 2 }}>
                    <Link href="#protectedanimals" sx={linkStyling}>#</Link> Protected Animals
                </Typography>
            </Box>

            <Box>
                <Definition title="Protected Animals">
                    <ProtectedAnimal animalName="Halibut" animalImageName="halibut.png" />
                    <ProtectedAnimal animalName="Bluefin Tuna" animalImageName="bluefintuna.png" />
                    <ProtectedAnimal animalName="Eel" animalImageName="eel.png" />
                    <ProtectedAnimal animalName="Grouper" animalImageName="grouper.png" />
                    <ProtectedAnimal animalName="Orange Grouper" animalImageName="orangegrouper.png" />
                    <ProtectedAnimal animalName="Potato Cod" animalImageName="potatocod.png" />
                    <ProtectedAnimal animalName="Sawfish" animalImageName="sawfish.png" />
                    <ProtectedAnimal animalName="Shark" animalImageName="shark.png" />
                    <ProtectedAnimal animalName="Smalltooth Sawfish" animalImageName="smalltoothsawfish.png" />
                    <ProtectedAnimal animalName="Southern Bluefin Tuna" animalImageName="southernbluefintuna.png" />
                    <ProtectedAnimal animalName="Turtle" animalImageName="turtle.png" />
                    <ProtectedAnimal animalName="White Shark" animalImageName="whiteshark.png" />
                    <ProtectedAnimal animalName="Winter Skate" animalImageName="winterskate.png" />
                    <ProtectedAnimal animalName="Mountain Lion" animalImageName="mountainlion.png" />
                    <ProtectedAnimal animalName="Panther" animalImageName="panther.png" />
                </Definition>
            </Box>
        </Box>
    )
}
